export default __webpack_public_path__ + "static/media/rotate-smartphone.97ee68a4.svg";